<template>
  <ul
    class="tm-colored-ul"
    :class="{
      [`tm-colored-ul--${color}`]: true,
      'tm-colored-ul__circle': !checkmark,
      'tm-colored-ul__checkmark': checkmark,
    }"
    :style="`--line-height: ${lineHeight}; --circle-size: ${circleSize}; --circle-left: ${circleLeft};`"
  >
    <slot />
  </ul>
</template>

<script lang="ts">
import { defineComponent, type PropType } from '@/composition/vue/compositionApi'

export type CircleColors = '' | 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'neutral' | 'light' | 'emphasize'

export default defineComponent({
  name: 'TmColoredUl',
  props: {
    circleSize: {
      type: String,
      default: '6px',
    },
    circleLeft: {
      type: String,
      default: '0',
    },
    lineHeight: {
      type: String,
      default: '20px',
    },
    color: {
      type: String as PropType<CircleColors>,
      default: 'blue',
    },
    checkmark: {
      type: Boolean,
    },
  },
})
</script>

<style lang="scss" scoped>
.tm-colored-ul {
  --circle-size: 6px;
  --line-height: 20px;
  --circle-color: #{$blue};
  --circle-left: 0;
  list-style: none;

  > :deep(li) {
    line-height: var(--line-height);
    text-align: start;
    padding-left: 14px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: calc((var(--line-height) - var(--circle-size)) / 2);
      left: var(--circle-left);
      display: block;
      flex-shrink: 0;
      width: var(--circle-size);
      height: var(--circle-size);
      margin-right: 8px;
      border-radius: 50%;
      background: var(--circle-color);
    }
  }

  &__checkmark {
    > :deep(li) {
      padding-left: 22px;
      &:before {
        background: url('@/assets/images/check.svg') no-repeat center;
        width: 16px;
        height: 16px;
        top: 2px;
      }
    }
  }

  &--blue {
    --circle-color: #{$blue};
  }
  &--green {
    --circle-color: #{$green};
  }
  &--red {
    --circle-color: #{$red};
  }
  &--orange {
    --circle-color: #{$orange};
  }
  &--gray {
    --circle-color: #{$gray};
  }
  &--neutral {
    --circle-color: #{$neutral};
  }
  &--light {
    --circle-color: #{$light};
  }
  &--emphasize {
    --circle-color: #{$emphasize};
  }
}
</style>
